import { Languages } from "src/common/descriptions/types";
import { IncomeRecordsDescriptions } from "./types";

const DescriptionsEnUs: IncomeRecordsDescriptions = {
    TITLE: "Income Records",
    TABLE: {
        ACTION_BUTTON: "Get Records",
        SEARCH_PLACEHOLDER: "Search Record",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Datetime",
        DESCRIPTION: "Description",
        TOTAL: "Total",
        IS_LOAN: "Is Loan",
    },
    CREATE: "Create Record",
}

const DescriptionsEsUs: IncomeRecordsDescriptions = {
    TITLE: "Registro de Ingresos",
    TABLE: {
        ACTION_BUTTON: "Ver Registros",
        SEARCH_PLACEHOLDER: "Buscar Registro",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        DATETIME: "Fecha",
        DESCRIPTION: "Descripción",
        TOTAL: "Total",
        IS_LOAN: "Es Préstamo",
    },
    CREATE: "Crear Registro",
}

export const incomeRecordsDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}